<template>
    <div class="submitSuccess">
        <p><img src="../../assets/img/submit.svg" /></p>
        <h1>提交成功</h1>
        <p>谢谢反馈你的建议,平台会虚心吸取你的意见</p>
        <p @click="toReturn">返回课程详细页</p>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        toReturn(){
            window.history.go(-2);
        }
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px){
    .submitSuccess{
        img{
            margin-top: 150px;
        }
    }
}
@media screen and (min-width: 1029px) {
    .submitSuccess{
        height: 900px;
        img{
            margin-top: 200px;
        }
    }
}
.submitSuccess{
    width: 100%;
    img{
        width: 46px;
        height: 46px;
    }
    h1,p{
        text-align: center;
    }
    h1{
        font-size: 24px;
        color: #19191A;
        margin: 20px 0 10px;
    }
    p{
        font-size: 14px;
        color: rgba(25,25,26,0.80);
        &:last-child{
            color: #0061FE;
            cursor: pointer;
            margin-top: 14px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/class/SubmitSuccess.vue